import * as actions from 'redux/actions/keywords.actions'

const updateKeyword = (state, { type, payload = {} }) => {
  switch (type) {
    case actions.getKeywordSerpSuccess.type:
      return {
        ...state,
        serp: payload.data,
        error: false
      }
    case actions.getKeywordHistorySuccess.type:
      return {
        ...state,
        history: payload.data,
        error: false
      }
    default:
      return {
        ...state,
        error: false
      }
  }
}

export default updateKeyword
